import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-site-header',
  standalone: false,
  templateUrl: './site-header.html',
  styleUrl: './site-header.css',
})
export class SiteHeader {

  public helpIsExpanded: boolean = false;


  toggleHelp() {
    this.helpIsExpanded = !this.helpIsExpanded;
  }

  onAuditClick() {
    window.open(environment.auditUrl, '_blank');
  }

  onDocumentationClick() {
    window.open(`${environment.suiteUrl}/documentation`, '_blank');
  }



}
